import { useEffect, useState } from "react";

/**
 * Public IP for timesheet enrichment.
 * Avoids geolocation-db.com (blocked / dead → console ERR_CONNECTION_REFUSED).
 */
const useIpAddress = () => {
  const [data, setData] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        if (!res.ok) return;
        const json = await res.json();
        if (cancelled) return;
        setData({
          IPv4: json.ip,
          ip: json.ip,
          address: null,
        });
      } catch (_err) {
        // Silent — IP enrichment is best-effort.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return data;
};

export default useIpAddress;
